// Import dependencies
import React from 'react';

// Import Styling
import './Header.css';
// import ollilogo from '../../../res/olli_01.gif';
// import dcelogo from '../../res/olli_03.gif';

// Simple Header Component
class Header extends React.Component {
    render() {
        return (
          <div>
            <div id="header_top" className="pt-1">
              <div id="header_partition">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-house float-left" viewBox="0 0 16 16">
                  <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293zM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5z"></path>
                </svg>
                <a href='/'><h2 style={{textAlign: 'center', color: 'white', textDecoration: 'underline'}} className='float-left ml-2 pl-1'>Home</h2></a>
              </div>
            </div>
            <div id="main-content"></div>
          </div>
        )
    }
}

export default Header;
